import React, {Component} from 'react';
import $ from 'jquery';

export default class Filters extends Component {
    constructor(props) {
        super(props);

        this.state = {
            Continents: ["all"],
            PriceList: ["all"]
        }
    }

    componentWillMount() {
        $("ul.tags a").unbind("click");
        $("ul.tags a").unbind("click", this.setOptions);
    }

    componentDidMount() {
        // $(document).on("click", "ul.tags a", this.setOptions.bind(this));
        $("ul.tags a").click((e) => {
            this.setOptions(e)
        });

        $(window).scroll(function () {
            if ($("div.gallery").length > 4) {
                debugger;
            }
        })
    }

    componentWillUnmount() {
        this.setState({Continents: ["all"], PriceList: ["all"]});
    }

    setOptions(e) {
        let _type = e.currentTarget.attributes["data-type"].value;
        let _option = e.currentTarget.attributes["data-option"].value;

        if (!$(e.currentTarget).hasClass("selected-tag")) {
            if (_option == "all") {
                $("ul.tags [data-type=" + _type + "]").removeClass("selected-tag");
                $(e.currentTarget).addClass("selected-tag");

                if (_type == "continents") {
                    this.setState({Continents: ["all"]}, () => {
                        this.filterByOptions()
                    });
                }
                else {
                    this.setState({PriceList: ["all"]}, () => {
                        this.filterByOptions()
                    });
                }
            }
            else {
                $("ul.tags [data-type=" + _type + "]").each((index, elem) => {
                    let opt = $(elem).attr("data-option");
                    if (opt == "all") {
                        $(elem).removeClass("selected-tag");
                    }
                    else {
                        if (opt == _option) {
                            $(elem).addClass("selected-tag");

                            return;
                        }
                    }
                })
                if (_type == "continents") {
                    let _Continents = this.state.Continents;
                    _Continents = _Continents.filter((continent) => {
                        return continent != "all"
                    });
                    _Continents.push(_option);
                    this.setState({Continents: _Continents}, () => {
                        this.filterByOptions()
                    });
                }
                else {
                    let _PriceList = this.state.PriceList;
                    _PriceList = _PriceList.filter((price) => {
                        return price != "all"
                    });
                    _PriceList.push(_option);
                    this.setState({PriceList: _PriceList}, () => {
                        this.filterByOptions()
                    });
                }
            }
        }
        else {
            if (_option != "all") {

                if ($("ul.tags a.selected-tag[data-type=" + _type + "]").length == 1) { //only one selected option is there
                    $("ul.tags [data-type=" + _type + "][data-option='all']").addClass("selected-tag");
                    if (_type == "continents") {
                        this.setState({Continents: ["all"]}, () => {
                            this.filterByOptions()
                        });
                    }
                    else {
                        this.setState({PriceList: ["all"]}, () => {
                            this.filterByOptions()
                        });
                    }
                    e.currentTarget.classList.remove("selected-tag");
                }
                else {
                    e.currentTarget.classList.remove("selected-tag");
                    if (_type == "continents") {
                        let _Continents = this.state.Continents;
                        _Continents = _Continents.filter((continent) => {
                            return continent != _option
                        });
                        this.setState({Continents: _Continents}, () => {
                            this.filterByOptions()
                        });
                    }
                    else {
                        let _PriceList = this.state.PriceList;
                        _PriceList = _PriceList.filter((price) => {
                            return price != _option
                        });
                        this.setState({PriceList: _PriceList}, () => {
                            this.filterByOptions()
                        });
                    }
                }
            }
        }
    }

    filterByOptions() {
        let {Continents, PriceList} = this.state;
        this.props.filterByOptions(Continents, PriceList);
    }

    render() {
        return (<section id="secFilters">
            <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        <label>Continents:</label>
                        <ul className="tags">
                            <li><a className="selected-tag tag" data-type="continents" data-option="all"
                                   style={{cursor: 'pointer'}}>All</a>
                            </li>
                            <li><a className="tag" data-type="continents" data-option="asia"
                                   style={{cursor: 'pointer'}}>Asia</a></li>
                            <li><a className="tag" data-type="continents" data-option="africa"
                                   style={{cursor: 'pointer'}}>Africa</a>
                            </li>
                            <li><a className="tag" data-type="continents" data-option="north america"
                                   style={{cursor: 'pointer'}}>North
                                America</a></li>
                            <li><a className="tag" data-type="continents" data-option="south america"
                                   style={{cursor: 'pointer'}}>South
                                America</a></li>
                            <li><a className="tag" data-type="continents" data-option="antarctica"
                                   style={{cursor: 'pointer'}}>Antarctica</a>
                            </li>
                            <li><a className="tag" data-type="continents" data-option="europe"
                                   style={{cursor: 'pointer'}}>Europe</a>
                            </li>
                            <li><a className="tag" data-type="continents" data-option="australia/ocenia"
                                   style={{cursor: 'pointer'}}>Australia/Oceania</a>
                            </li>
                        </ul>
                    </div>

                    <div className="col-md-12">
                        <div className="form-group">
                            <label>Price:</label>
                            <ul className="tags">
                                <li><a className="selected-tag tag" data-type="pricelist" data-option="all"
                                       style={{cursor: 'pointer'}}>All</a>
                                </li>
                                <li><a className="tag" data-type="pricelist" data-option="2"
                                       style={{cursor: 'pointer'}}>$$</a></li>
                                <li><a className="tag" data-type="pricelist" data-option="3"
                                       style={{cursor: 'pointer'}}>$$$</a>
                                </li>
                                <li><a className="tag" data-type="pricelist" data-option="4"
                                       style={{cursor: 'pointer'}}>$$$$</a>
                                </li>
                                <li><a className="tag" data-type="pricelist" data-option="5"
                                       style={{cursor: 'pointer'}}>$$$$$</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>)
    }
}


// WEBPACK FOOTER //
// ./src/Filters.js